var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal d-flex-column"},[_c('div',{staticClass:"header flex-0 d-flex"},[_c('div',{staticClass:"flex-1"},[_c('h2',[_vm._v(_vm._s(_vm.heading))])]),_c('button',{staticClass:"flex-0 close-button",on:{"click":_vm.handleClick}},[_vm._v(" X ")])]),_c('div',{staticClass:"content flex-1"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }